/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BillingCashSessionsListParams,
  BillingExportsRetrieveParams,
  BillingInvoicesListParams,
  BillingPaymentRoutingListParams,
  BillingPaymentsListParams,
  BillingSettings,
  BillingSettingsListParams,
  CashSession,
  CloseSessionRequest,
  InvoiceCreateRequest,
  InvoiceDetail,
  MobilePaymentRequest,
  OpenSessionRequest,
  PaginatedBillingSettingsList,
  PaginatedCashSessionList,
  PaginatedInvoiceList,
  PaginatedPaymentList,
  PaginatedPaymentRoutingList,
  PatchedBillingSettingsRequest,
  PatchedInvoiceDraftRequest,
  PatchedPaymentRoutingRequest,
  Payment,
  PaymentRouting,
  ReasonRequest,
  RecordPaymentRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type billingCashSessionsListResponse200 = {
  data: PaginatedCashSessionList
  status: 200
}
    
export type billingCashSessionsListResponseSuccess = (billingCashSessionsListResponse200) & {
  headers: Headers;
};
;

export type billingCashSessionsListResponse = (billingCashSessionsListResponseSuccess)

export const getBillingCashSessionsListUrl = (params?: BillingCashSessionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/cash-sessions/?${stringifiedParams}` : `/api/v1/billing/cash-sessions/`
}

export const billingCashSessionsList = async (params?: BillingCashSessionsListParams, options?: RequestInit): Promise<billingCashSessionsListResponse> => {
  
  return apiFetch<billingCashSessionsListResponse>(getBillingCashSessionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingCashSessionsListQueryKey = (params?: BillingCashSessionsListParams,) => {
    return [
    `/api/v1/billing/cash-sessions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingCashSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof billingCashSessionsList>>, TError = unknown>(params?: BillingCashSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingCashSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingCashSessionsList>>> = ({ signal }) => billingCashSessionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingCashSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof billingCashSessionsList>>>
export type BillingCashSessionsListQueryError = unknown


export function useBillingCashSessionsList<TData = Awaited<ReturnType<typeof billingCashSessionsList>>, TError = unknown>(
 params: undefined |  BillingCashSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsList>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsList<TData = Awaited<ReturnType<typeof billingCashSessionsList>>, TError = unknown>(
 params?: BillingCashSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsList>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsList<TData = Awaited<ReturnType<typeof billingCashSessionsList>>, TError = unknown>(
 params?: BillingCashSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingCashSessionsList<TData = Awaited<ReturnType<typeof billingCashSessionsList>>, TError = unknown>(
 params?: BillingCashSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingCashSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type billingCashSessionsRetrieveResponse200 = {
  data: CashSession
  status: 200
}
    
export type billingCashSessionsRetrieveResponseSuccess = (billingCashSessionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingCashSessionsRetrieveResponse = (billingCashSessionsRetrieveResponseSuccess)

export const getBillingCashSessionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/billing/cash-sessions/${id}/`
}

export const billingCashSessionsRetrieve = async (id: string, options?: RequestInit): Promise<billingCashSessionsRetrieveResponse> => {
  
  return apiFetch<billingCashSessionsRetrieveResponse>(getBillingCashSessionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingCashSessionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/billing/cash-sessions/${id}/`
    ] as const;
    }

    
export const getBillingCashSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingCashSessionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>> = ({ signal }) => billingCashSessionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingCashSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>>
export type BillingCashSessionsRetrieveQueryError = unknown


export function useBillingCashSessionsRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingCashSessionsRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingCashSessionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type billingCashSessionsCloseCreateResponse200 = {
  data: CashSession
  status: 200
}
    
export type billingCashSessionsCloseCreateResponseSuccess = (billingCashSessionsCloseCreateResponse200) & {
  headers: Headers;
};
;

export type billingCashSessionsCloseCreateResponse = (billingCashSessionsCloseCreateResponseSuccess)

export const getBillingCashSessionsCloseCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/cash-sessions/${id}/close/`
}

export const billingCashSessionsCloseCreate = async (id: string,
    closeSessionRequest: CloseSessionRequest, options?: RequestInit): Promise<billingCashSessionsCloseCreateResponse> => {
  
  return apiFetch<billingCashSessionsCloseCreateResponse>(getBillingCashSessionsCloseCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closeSessionRequest,)
  }
);}




export const getBillingCashSessionsCloseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>, TError,{id: string;data: CloseSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>, TError,{id: string;data: CloseSessionRequest}, TContext> => {

const mutationKey = ['billingCashSessionsCloseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>, {id: string;data: CloseSessionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingCashSessionsCloseCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingCashSessionsCloseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>>
    export type BillingCashSessionsCloseCreateMutationBody = CloseSessionRequest
    export type BillingCashSessionsCloseCreateMutationError = unknown

    export const useBillingCashSessionsCloseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>, TError,{id: string;data: CloseSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingCashSessionsCloseCreate>>,
        TError,
        {id: string;data: CloseSessionRequest},
        TContext
      > => {

      const mutationOptions = getBillingCashSessionsCloseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingCashSessionsMineRetrieveResponse200 = {
  data: CashSession
  status: 200
}
    
export type billingCashSessionsMineRetrieveResponseSuccess = (billingCashSessionsMineRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingCashSessionsMineRetrieveResponse = (billingCashSessionsMineRetrieveResponseSuccess)

export const getBillingCashSessionsMineRetrieveUrl = () => {


  

  return `/api/v1/billing/cash-sessions/mine/`
}

export const billingCashSessionsMineRetrieve = async ( options?: RequestInit): Promise<billingCashSessionsMineRetrieveResponse> => {
  
  return apiFetch<billingCashSessionsMineRetrieveResponse>(getBillingCashSessionsMineRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingCashSessionsMineRetrieveQueryKey = () => {
    return [
    `/api/v1/billing/cash-sessions/mine/`
    ] as const;
    }

    
export const getBillingCashSessionsMineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingCashSessionsMineRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>> = ({ signal }) => billingCashSessionsMineRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingCashSessionsMineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>>
export type BillingCashSessionsMineRetrieveQueryError = unknown


export function useBillingCashSessionsMineRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsMineRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingCashSessionsMineRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingCashSessionsMineRetrieve<TData = Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingCashSessionsMineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingCashSessionsMineRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type billingCashSessionsOpenCreateResponse201 = {
  data: CashSession
  status: 201
}
    
export type billingCashSessionsOpenCreateResponseSuccess = (billingCashSessionsOpenCreateResponse201) & {
  headers: Headers;
};
;

export type billingCashSessionsOpenCreateResponse = (billingCashSessionsOpenCreateResponseSuccess)

export const getBillingCashSessionsOpenCreateUrl = () => {


  

  return `/api/v1/billing/cash-sessions/open/`
}

export const billingCashSessionsOpenCreate = async (openSessionRequest: OpenSessionRequest, options?: RequestInit): Promise<billingCashSessionsOpenCreateResponse> => {
  
  return apiFetch<billingCashSessionsOpenCreateResponse>(getBillingCashSessionsOpenCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      openSessionRequest,)
  }
);}




export const getBillingCashSessionsOpenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>, TError,{data: OpenSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>, TError,{data: OpenSessionRequest}, TContext> => {

const mutationKey = ['billingCashSessionsOpenCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>, {data: OpenSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  billingCashSessionsOpenCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingCashSessionsOpenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>>
    export type BillingCashSessionsOpenCreateMutationBody = OpenSessionRequest
    export type BillingCashSessionsOpenCreateMutationError = unknown

    export const useBillingCashSessionsOpenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>, TError,{data: OpenSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingCashSessionsOpenCreate>>,
        TError,
        {data: OpenSessionRequest},
        TContext
      > => {

      const mutationOptions = getBillingCashSessionsOpenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * For the accountant (P2-12): invoices or payments over a period, Excel or CSV.
 */
export type billingExportsRetrieveResponse200 = {
  data: Blob
  status: 200
}
    
export type billingExportsRetrieveResponseSuccess = (billingExportsRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingExportsRetrieveResponse = (billingExportsRetrieveResponseSuccess)

export const getBillingExportsRetrieveUrl = (params?: BillingExportsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/exports/?${stringifiedParams}` : `/api/v1/billing/exports/`
}

export const billingExportsRetrieve = async (params?: BillingExportsRetrieveParams, options?: RequestInit): Promise<billingExportsRetrieveResponse> => {
  
  return apiFetch<billingExportsRetrieveResponse>(getBillingExportsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingExportsRetrieveQueryKey = (params?: BillingExportsRetrieveParams,) => {
    return [
    `/api/v1/billing/exports/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingExportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingExportsRetrieve>>, TError = unknown>(params?: BillingExportsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingExportsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingExportsRetrieve>>> = ({ signal }) => billingExportsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingExportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingExportsRetrieve>>>
export type BillingExportsRetrieveQueryError = unknown


export function useBillingExportsRetrieve<TData = Awaited<ReturnType<typeof billingExportsRetrieve>>, TError = unknown>(
 params: undefined |  BillingExportsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingExportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingExportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingExportsRetrieve<TData = Awaited<ReturnType<typeof billingExportsRetrieve>>, TError = unknown>(
 params?: BillingExportsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingExportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingExportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingExportsRetrieve<TData = Awaited<ReturnType<typeof billingExportsRetrieve>>, TError = unknown>(
 params?: BillingExportsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingExportsRetrieve<TData = Awaited<ReturnType<typeof billingExportsRetrieve>>, TError = unknown>(
 params?: BillingExportsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingExportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingExportsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type billingInvoicesListResponse200 = {
  data: PaginatedInvoiceList
  status: 200
}
    
export type billingInvoicesListResponseSuccess = (billingInvoicesListResponse200) & {
  headers: Headers;
};
;

export type billingInvoicesListResponse = (billingInvoicesListResponseSuccess)

export const getBillingInvoicesListUrl = (params?: BillingInvoicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/invoices/?${stringifiedParams}` : `/api/v1/billing/invoices/`
}

export const billingInvoicesList = async (params?: BillingInvoicesListParams, options?: RequestInit): Promise<billingInvoicesListResponse> => {
  
  return apiFetch<billingInvoicesListResponse>(getBillingInvoicesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingInvoicesListQueryKey = (params?: BillingInvoicesListParams,) => {
    return [
    `/api/v1/billing/invoices/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingInvoicesListQueryOptions = <TData = Awaited<ReturnType<typeof billingInvoicesList>>, TError = unknown>(params?: BillingInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingInvoicesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingInvoicesList>>> = ({ signal }) => billingInvoicesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingInvoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesList>>>
export type BillingInvoicesListQueryError = unknown


export function useBillingInvoicesList<TData = Awaited<ReturnType<typeof billingInvoicesList>>, TError = unknown>(
 params: undefined |  BillingInvoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicesList<TData = Awaited<ReturnType<typeof billingInvoicesList>>, TError = unknown>(
 params?: BillingInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicesList<TData = Awaited<ReturnType<typeof billingInvoicesList>>, TError = unknown>(
 params?: BillingInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingInvoicesList<TData = Awaited<ReturnType<typeof billingInvoicesList>>, TError = unknown>(
 params?: BillingInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingInvoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-126: typed by hand — kept as a draft (`draft: true`) or issued at once.
 */
export type billingInvoicesCreateResponse201 = {
  data: InvoiceDetail
  status: 201
}
    
export type billingInvoicesCreateResponseSuccess = (billingInvoicesCreateResponse201) & {
  headers: Headers;
};
;

export type billingInvoicesCreateResponse = (billingInvoicesCreateResponseSuccess)

export const getBillingInvoicesCreateUrl = () => {


  

  return `/api/v1/billing/invoices/`
}

export const billingInvoicesCreate = async (invoiceCreateRequest: InvoiceCreateRequest, options?: RequestInit): Promise<billingInvoicesCreateResponse> => {
  
  return apiFetch<billingInvoicesCreateResponse>(getBillingInvoicesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invoiceCreateRequest,)
  }
);}




export const getBillingInvoicesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCreate>>, TError,{data: InvoiceCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCreate>>, TError,{data: InvoiceCreateRequest}, TContext> => {

const mutationKey = ['billingInvoicesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesCreate>>, {data: InvoiceCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  billingInvoicesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesCreate>>>
    export type BillingInvoicesCreateMutationBody = InvoiceCreateRequest
    export type BillingInvoicesCreateMutationError = unknown

    export const useBillingInvoicesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCreate>>, TError,{data: InvoiceCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesCreate>>,
        TError,
        {data: InvoiceCreateRequest},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingInvoicesRetrieveResponse200 = {
  data: InvoiceDetail
  status: 200
}
    
export type billingInvoicesRetrieveResponseSuccess = (billingInvoicesRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingInvoicesRetrieveResponse = (billingInvoicesRetrieveResponseSuccess)

export const getBillingInvoicesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/`
}

export const billingInvoicesRetrieve = async (id: string, options?: RequestInit): Promise<billingInvoicesRetrieveResponse> => {
  
  return apiFetch<billingInvoicesRetrieveResponse>(getBillingInvoicesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingInvoicesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/billing/invoices/${id}/`
    ] as const;
    }

    
export const getBillingInvoicesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingInvoicesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingInvoicesRetrieve>>> = ({ signal }) => billingInvoicesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingInvoicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesRetrieve>>>
export type BillingInvoicesRetrieveQueryError = unknown


export function useBillingInvoicesRetrieve<TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicesRetrieve<TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicesRetrieve<TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingInvoicesRetrieve<TData = Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingInvoicesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Change a draft (the whole draft is sent); an issued invoice never changes.
 */
export type billingInvoicesPartialUpdateResponse200 = {
  data: InvoiceDetail
  status: 200
}
    
export type billingInvoicesPartialUpdateResponseSuccess = (billingInvoicesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type billingInvoicesPartialUpdateResponse = (billingInvoicesPartialUpdateResponseSuccess)

export const getBillingInvoicesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/`
}

export const billingInvoicesPartialUpdate = async (id: string,
    patchedInvoiceDraftRequest: PatchedInvoiceDraftRequest, options?: RequestInit): Promise<billingInvoicesPartialUpdateResponse> => {
  
  return apiFetch<billingInvoicesPartialUpdateResponse>(getBillingInvoicesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedInvoiceDraftRequest,)
  }
);}




export const getBillingInvoicesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>, TError,{id: string;data: PatchedInvoiceDraftRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>, TError,{id: string;data: PatchedInvoiceDraftRequest}, TContext> => {

const mutationKey = ['billingInvoicesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>, {id: string;data: PatchedInvoiceDraftRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingInvoicesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>>
    export type BillingInvoicesPartialUpdateMutationBody = PatchedInvoiceDraftRequest
    export type BillingInvoicesPartialUpdateMutationError = unknown

    export const useBillingInvoicesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>, TError,{id: string;data: PatchedInvoiceDraftRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesPartialUpdate>>,
        TError,
        {id: string;data: PatchedInvoiceDraftRequest},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingInvoicesCancelCreateResponse200 = {
  data: InvoiceDetail
  status: 200
}
    
export type billingInvoicesCancelCreateResponseSuccess = (billingInvoicesCancelCreateResponse200) & {
  headers: Headers;
};
;

export type billingInvoicesCancelCreateResponse = (billingInvoicesCancelCreateResponseSuccess)

export const getBillingInvoicesCancelCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/cancel/`
}

export const billingInvoicesCancelCreate = async (id: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<billingInvoicesCancelCreateResponse> => {
  
  return apiFetch<billingInvoicesCancelCreateResponse>(getBillingInvoicesCancelCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reasonRequest,)
  }
);}




export const getBillingInvoicesCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext> => {

const mutationKey = ['billingInvoicesCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesCancelCreate>>, {id: string;data: ReasonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingInvoicesCancelCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesCancelCreate>>>
    export type BillingInvoicesCancelCreateMutationBody = ReasonRequest
    export type BillingInvoicesCancelCreateMutationError = unknown

    export const useBillingInvoicesCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesCancelCreate>>,
        TError,
        {id: string;data: ReasonRequest},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Draft → numbered invoice or quote (numbering of the agency), PDF with the layout.
 */
export type billingInvoicesIssueCreateResponse200 = {
  data: InvoiceDetail
  status: 200
}
    
export type billingInvoicesIssueCreateResponseSuccess = (billingInvoicesIssueCreateResponse200) & {
  headers: Headers;
};
;

export type billingInvoicesIssueCreateResponse = (billingInvoicesIssueCreateResponseSuccess)

export const getBillingInvoicesIssueCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/issue/`
}

export const billingInvoicesIssueCreate = async (id: string, options?: RequestInit): Promise<billingInvoicesIssueCreateResponse> => {
  
  return apiFetch<billingInvoicesIssueCreateResponse>(getBillingInvoicesIssueCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getBillingInvoicesIssueCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesIssueCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesIssueCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['billingInvoicesIssueCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesIssueCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  billingInvoicesIssueCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesIssueCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesIssueCreate>>>
    
    export type BillingInvoicesIssueCreateMutationError = unknown

    export const useBillingInvoicesIssueCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesIssueCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesIssueCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesIssueCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingInvoicesMobileMoneyCreateResponse201 = {
  data: Payment
  status: 201
}
    
export type billingInvoicesMobileMoneyCreateResponseSuccess = (billingInvoicesMobileMoneyCreateResponse201) & {
  headers: Headers;
};
;

export type billingInvoicesMobileMoneyCreateResponse = (billingInvoicesMobileMoneyCreateResponseSuccess)

export const getBillingInvoicesMobileMoneyCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/mobile-money/`
}

export const billingInvoicesMobileMoneyCreate = async (id: string,
    mobilePaymentRequest: MobilePaymentRequest, options?: RequestInit): Promise<billingInvoicesMobileMoneyCreateResponse> => {
  
  return apiFetch<billingInvoicesMobileMoneyCreateResponse>(getBillingInvoicesMobileMoneyCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mobilePaymentRequest,)
  }
);}




export const getBillingInvoicesMobileMoneyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>, TError,{id: string;data: MobilePaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>, TError,{id: string;data: MobilePaymentRequest}, TContext> => {

const mutationKey = ['billingInvoicesMobileMoneyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>, {id: string;data: MobilePaymentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingInvoicesMobileMoneyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesMobileMoneyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>>
    export type BillingInvoicesMobileMoneyCreateMutationBody = MobilePaymentRequest
    export type BillingInvoicesMobileMoneyCreateMutationError = unknown

    export const useBillingInvoicesMobileMoneyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>, TError,{id: string;data: MobilePaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesMobileMoneyCreate>>,
        TError,
        {id: string;data: MobilePaymentRequest},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesMobileMoneyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Cash (receipt compulsory, open cash desk needed), transfer or deposit.
 */
export type billingInvoicesPayCreateResponse201 = {
  data: Payment
  status: 201
}
    
export type billingInvoicesPayCreateResponseSuccess = (billingInvoicesPayCreateResponse201) & {
  headers: Headers;
};
;

export type billingInvoicesPayCreateResponse = (billingInvoicesPayCreateResponseSuccess)

export const getBillingInvoicesPayCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/pay/`
}

export const billingInvoicesPayCreate = async (id: string,
    recordPaymentRequest: RecordPaymentRequest, options?: RequestInit): Promise<billingInvoicesPayCreateResponse> => {
  
  return apiFetch<billingInvoicesPayCreateResponse>(getBillingInvoicesPayCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      recordPaymentRequest,)
  }
);}




export const getBillingInvoicesPayCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPayCreate>>, TError,{id: string;data: RecordPaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPayCreate>>, TError,{id: string;data: RecordPaymentRequest}, TContext> => {

const mutationKey = ['billingInvoicesPayCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesPayCreate>>, {id: string;data: RecordPaymentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingInvoicesPayCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesPayCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesPayCreate>>>
    export type BillingInvoicesPayCreateMutationBody = RecordPaymentRequest
    export type BillingInvoicesPayCreateMutationError = unknown

    export const useBillingInvoicesPayCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesPayCreate>>, TError,{id: string;data: RecordPaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesPayCreate>>,
        TError,
        {id: string;data: RecordPaymentRequest},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesPayCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingInvoicesSendCreateResponse202 = {
  data: void
  status: 202
}
    
export type billingInvoicesSendCreateResponseSuccess = (billingInvoicesSendCreateResponse202) & {
  headers: Headers;
};
;

export type billingInvoicesSendCreateResponse = (billingInvoicesSendCreateResponseSuccess)

export const getBillingInvoicesSendCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/send/`
}

export const billingInvoicesSendCreate = async (id: string, options?: RequestInit): Promise<billingInvoicesSendCreateResponse> => {
  
  return apiFetch<billingInvoicesSendCreateResponse>(getBillingInvoicesSendCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getBillingInvoicesSendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesSendCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['billingInvoicesSendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesSendCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  billingInvoicesSendCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesSendCreate>>>
    
    export type BillingInvoicesSendCreateMutationError = unknown

    export const useBillingInvoicesSendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesSendCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesSendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type billingInvoicesToInvoiceCreateResponse201 = {
  data: InvoiceDetail
  status: 201
}
    
export type billingInvoicesToInvoiceCreateResponseSuccess = (billingInvoicesToInvoiceCreateResponse201) & {
  headers: Headers;
};
;

export type billingInvoicesToInvoiceCreateResponse = (billingInvoicesToInvoiceCreateResponseSuccess)

export const getBillingInvoicesToInvoiceCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/invoices/${id}/to-invoice/`
}

export const billingInvoicesToInvoiceCreate = async (id: string, options?: RequestInit): Promise<billingInvoicesToInvoiceCreateResponse> => {
  
  return apiFetch<billingInvoicesToInvoiceCreateResponse>(getBillingInvoicesToInvoiceCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getBillingInvoicesToInvoiceCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['billingInvoicesToInvoiceCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  billingInvoicesToInvoiceCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingInvoicesToInvoiceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>>
    
    export type BillingInvoicesToInvoiceCreateMutationError = unknown

    export const useBillingInvoicesToInvoiceCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingInvoicesToInvoiceCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getBillingInvoicesToInvoiceCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One row per agency (created empty on first read: the starting order applies).
 */
export type billingPaymentRoutingListResponse200 = {
  data: PaginatedPaymentRoutingList
  status: 200
}
    
export type billingPaymentRoutingListResponseSuccess = (billingPaymentRoutingListResponse200) & {
  headers: Headers;
};
;

export type billingPaymentRoutingListResponse = (billingPaymentRoutingListResponseSuccess)

export const getBillingPaymentRoutingListUrl = (params?: BillingPaymentRoutingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/payment-routing/?${stringifiedParams}` : `/api/v1/billing/payment-routing/`
}

export const billingPaymentRoutingList = async (params?: BillingPaymentRoutingListParams, options?: RequestInit): Promise<billingPaymentRoutingListResponse> => {
  
  return apiFetch<billingPaymentRoutingListResponse>(getBillingPaymentRoutingListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingPaymentRoutingListQueryKey = (params?: BillingPaymentRoutingListParams,) => {
    return [
    `/api/v1/billing/payment-routing/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingPaymentRoutingListQueryOptions = <TData = Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError = unknown>(params?: BillingPaymentRoutingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingPaymentRoutingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPaymentRoutingList>>> = ({ signal }) => billingPaymentRoutingList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingPaymentRoutingListQueryResult = NonNullable<Awaited<ReturnType<typeof billingPaymentRoutingList>>>
export type BillingPaymentRoutingListQueryError = unknown


export function useBillingPaymentRoutingList<TData = Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError = unknown>(
 params: undefined |  BillingPaymentRoutingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentRoutingList>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentRoutingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentRoutingList<TData = Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError = unknown>(
 params?: BillingPaymentRoutingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentRoutingList>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentRoutingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentRoutingList<TData = Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError = unknown>(
 params?: BillingPaymentRoutingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingPaymentRoutingList<TData = Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError = unknown>(
 params?: BillingPaymentRoutingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingPaymentRoutingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency (created empty on first read: the starting order applies).
 */
export type billingPaymentRoutingRetrieveResponse200 = {
  data: PaymentRouting
  status: 200
}
    
export type billingPaymentRoutingRetrieveResponseSuccess = (billingPaymentRoutingRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingPaymentRoutingRetrieveResponse = (billingPaymentRoutingRetrieveResponseSuccess)

export const getBillingPaymentRoutingRetrieveUrl = (id: string,) => {


  

  return `/api/v1/billing/payment-routing/${id}/`
}

export const billingPaymentRoutingRetrieve = async (id: string, options?: RequestInit): Promise<billingPaymentRoutingRetrieveResponse> => {
  
  return apiFetch<billingPaymentRoutingRetrieveResponse>(getBillingPaymentRoutingRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingPaymentRoutingRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/billing/payment-routing/${id}/`
    ] as const;
    }

    
export const getBillingPaymentRoutingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingPaymentRoutingRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>> = ({ signal }) => billingPaymentRoutingRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingPaymentRoutingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>>
export type BillingPaymentRoutingRetrieveQueryError = unknown


export function useBillingPaymentRoutingRetrieve<TData = Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentRoutingRetrieve<TData = Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentRoutingRetrieve<TData = Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingPaymentRoutingRetrieve<TData = Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentRoutingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingPaymentRoutingRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency (created empty on first read: the starting order applies).
 */
export type billingPaymentRoutingPartialUpdateResponse200 = {
  data: PaymentRouting
  status: 200
}
    
export type billingPaymentRoutingPartialUpdateResponseSuccess = (billingPaymentRoutingPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type billingPaymentRoutingPartialUpdateResponse = (billingPaymentRoutingPartialUpdateResponseSuccess)

export const getBillingPaymentRoutingPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/billing/payment-routing/${id}/`
}

export const billingPaymentRoutingPartialUpdate = async (id: string,
    patchedPaymentRoutingRequest: PatchedPaymentRoutingRequest, options?: RequestInit): Promise<billingPaymentRoutingPartialUpdateResponse> => {
  
  return apiFetch<billingPaymentRoutingPartialUpdateResponse>(getBillingPaymentRoutingPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedPaymentRoutingRequest,)
  }
);}




export const getBillingPaymentRoutingPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>, TError,{id: string;data: PatchedPaymentRoutingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>, TError,{id: string;data: PatchedPaymentRoutingRequest}, TContext> => {

const mutationKey = ['billingPaymentRoutingPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>, {id: string;data: PatchedPaymentRoutingRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingPaymentRoutingPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingPaymentRoutingPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>>
    export type BillingPaymentRoutingPartialUpdateMutationBody = PatchedPaymentRoutingRequest
    export type BillingPaymentRoutingPartialUpdateMutationError = unknown

    export const useBillingPaymentRoutingPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>, TError,{id: string;data: PatchedPaymentRoutingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingPaymentRoutingPartialUpdate>>,
        TError,
        {id: string;data: PatchedPaymentRoutingRequest},
        TContext
      > => {

      const mutationOptions = getBillingPaymentRoutingPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Read only: a payment is never edited nor deleted, only cancelled with a reason.
 */
export type billingPaymentsListResponse200 = {
  data: PaginatedPaymentList
  status: 200
}
    
export type billingPaymentsListResponseSuccess = (billingPaymentsListResponse200) & {
  headers: Headers;
};
;

export type billingPaymentsListResponse = (billingPaymentsListResponseSuccess)

export const getBillingPaymentsListUrl = (params?: BillingPaymentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/payments/?${stringifiedParams}` : `/api/v1/billing/payments/`
}

export const billingPaymentsList = async (params?: BillingPaymentsListParams, options?: RequestInit): Promise<billingPaymentsListResponse> => {
  
  return apiFetch<billingPaymentsListResponse>(getBillingPaymentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingPaymentsListQueryKey = (params?: BillingPaymentsListParams,) => {
    return [
    `/api/v1/billing/payments/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingPaymentsListQueryOptions = <TData = Awaited<ReturnType<typeof billingPaymentsList>>, TError = unknown>(params?: BillingPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingPaymentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPaymentsList>>> = ({ signal }) => billingPaymentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingPaymentsListQueryResult = NonNullable<Awaited<ReturnType<typeof billingPaymentsList>>>
export type BillingPaymentsListQueryError = unknown


export function useBillingPaymentsList<TData = Awaited<ReturnType<typeof billingPaymentsList>>, TError = unknown>(
 params: undefined |  BillingPaymentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentsList<TData = Awaited<ReturnType<typeof billingPaymentsList>>, TError = unknown>(
 params?: BillingPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentsList<TData = Awaited<ReturnType<typeof billingPaymentsList>>, TError = unknown>(
 params?: BillingPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingPaymentsList<TData = Awaited<ReturnType<typeof billingPaymentsList>>, TError = unknown>(
 params?: BillingPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingPaymentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Read only: a payment is never edited nor deleted, only cancelled with a reason.
 */
export type billingPaymentsRetrieveResponse200 = {
  data: Payment
  status: 200
}
    
export type billingPaymentsRetrieveResponseSuccess = (billingPaymentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingPaymentsRetrieveResponse = (billingPaymentsRetrieveResponseSuccess)

export const getBillingPaymentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/billing/payments/${id}/`
}

export const billingPaymentsRetrieve = async (id: string, options?: RequestInit): Promise<billingPaymentsRetrieveResponse> => {
  
  return apiFetch<billingPaymentsRetrieveResponse>(getBillingPaymentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingPaymentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/billing/payments/${id}/`
    ] as const;
    }

    
export const getBillingPaymentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingPaymentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPaymentsRetrieve>>> = ({ signal }) => billingPaymentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingPaymentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingPaymentsRetrieve>>>
export type BillingPaymentsRetrieveQueryError = unknown


export function useBillingPaymentsRetrieve<TData = Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentsRetrieve<TData = Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingPaymentsRetrieve<TData = Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingPaymentsRetrieve<TData = Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingPaymentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Read only: a payment is never edited nor deleted, only cancelled with a reason.
 */
export type billingPaymentsCancelCreateResponse200 = {
  data: Payment
  status: 200
}
    
export type billingPaymentsCancelCreateResponseSuccess = (billingPaymentsCancelCreateResponse200) & {
  headers: Headers;
};
;

export type billingPaymentsCancelCreateResponse = (billingPaymentsCancelCreateResponseSuccess)

export const getBillingPaymentsCancelCreateUrl = (id: string,) => {


  

  return `/api/v1/billing/payments/${id}/cancel/`
}

export const billingPaymentsCancelCreate = async (id: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<billingPaymentsCancelCreateResponse> => {
  
  return apiFetch<billingPaymentsCancelCreateResponse>(getBillingPaymentsCancelCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reasonRequest,)
  }
);}




export const getBillingPaymentsCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPaymentsCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingPaymentsCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext> => {

const mutationKey = ['billingPaymentsCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingPaymentsCancelCreate>>, {id: string;data: ReasonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingPaymentsCancelCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingPaymentsCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof billingPaymentsCancelCreate>>>
    export type BillingPaymentsCancelCreateMutationBody = ReasonRequest
    export type BillingPaymentsCancelCreateMutationError = unknown

    export const useBillingPaymentsCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPaymentsCancelCreate>>, TError,{id: string;data: ReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingPaymentsCancelCreate>>,
        TError,
        {id: string;data: ReasonRequest},
        TContext
      > => {

      const mutationOptions = getBillingPaymentsCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One row per agency (created with the defaults on first read).
 */
export type billingSettingsListResponse200 = {
  data: PaginatedBillingSettingsList
  status: 200
}
    
export type billingSettingsListResponseSuccess = (billingSettingsListResponse200) & {
  headers: Headers;
};
;

export type billingSettingsListResponse = (billingSettingsListResponseSuccess)

export const getBillingSettingsListUrl = (params?: BillingSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/billing/settings/?${stringifiedParams}` : `/api/v1/billing/settings/`
}

export const billingSettingsList = async (params?: BillingSettingsListParams, options?: RequestInit): Promise<billingSettingsListResponse> => {
  
  return apiFetch<billingSettingsListResponse>(getBillingSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingSettingsListQueryKey = (params?: BillingSettingsListParams,) => {
    return [
    `/api/v1/billing/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBillingSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof billingSettingsList>>, TError = unknown>(params?: BillingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSettingsList>>> = ({ signal }) => billingSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof billingSettingsList>>>
export type BillingSettingsListQueryError = unknown


export function useBillingSettingsList<TData = Awaited<ReturnType<typeof billingSettingsList>>, TError = unknown>(
 params: undefined |  BillingSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSettingsList>>,
          TError,
          Awaited<ReturnType<typeof billingSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSettingsList<TData = Awaited<ReturnType<typeof billingSettingsList>>, TError = unknown>(
 params?: BillingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSettingsList>>,
          TError,
          Awaited<ReturnType<typeof billingSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSettingsList<TData = Awaited<ReturnType<typeof billingSettingsList>>, TError = unknown>(
 params?: BillingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingSettingsList<TData = Awaited<ReturnType<typeof billingSettingsList>>, TError = unknown>(
 params?: BillingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency (created with the defaults on first read).
 */
export type billingSettingsRetrieveResponse200 = {
  data: BillingSettings
  status: 200
}
    
export type billingSettingsRetrieveResponseSuccess = (billingSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type billingSettingsRetrieveResponse = (billingSettingsRetrieveResponseSuccess)

export const getBillingSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/billing/settings/${id}/`
}

export const billingSettingsRetrieve = async (id: string, options?: RequestInit): Promise<billingSettingsRetrieveResponse> => {
  
  return apiFetch<billingSettingsRetrieveResponse>(getBillingSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBillingSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/billing/settings/${id}/`
    ] as const;
    }

    
export const getBillingSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSettingsRetrieve>>> = ({ signal }) => billingSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof billingSettingsRetrieve>>>
export type BillingSettingsRetrieveQueryError = unknown


export function useBillingSettingsRetrieve<TData = Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSettingsRetrieve<TData = Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof billingSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSettingsRetrieve<TData = Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBillingSettingsRetrieve<TData = Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency (created with the defaults on first read).
 */
export type billingSettingsPartialUpdateResponse200 = {
  data: BillingSettings
  status: 200
}
    
export type billingSettingsPartialUpdateResponseSuccess = (billingSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type billingSettingsPartialUpdateResponse = (billingSettingsPartialUpdateResponseSuccess)

export const getBillingSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/billing/settings/${id}/`
}

export const billingSettingsPartialUpdate = async (id: string,
    patchedBillingSettingsRequest: PatchedBillingSettingsRequest, options?: RequestInit): Promise<billingSettingsPartialUpdateResponse> => {
  
  return apiFetch<billingSettingsPartialUpdateResponse>(getBillingSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedBillingSettingsRequest,)
  }
);}




export const getBillingSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSettingsPartialUpdate>>, TError,{id: string;data: PatchedBillingSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof billingSettingsPartialUpdate>>, TError,{id: string;data: PatchedBillingSettingsRequest}, TContext> => {

const mutationKey = ['billingSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingSettingsPartialUpdate>>, {id: string;data: PatchedBillingSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  billingSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BillingSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof billingSettingsPartialUpdate>>>
    export type BillingSettingsPartialUpdateMutationBody = PatchedBillingSettingsRequest
    export type BillingSettingsPartialUpdateMutationError = unknown

    export const useBillingSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSettingsPartialUpdate>>, TError,{id: string;data: PatchedBillingSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedBillingSettingsRequest},
        TContext
      > => {

      const mutationOptions = getBillingSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    